'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var adConfigMap = {
  favoritesHorizontal: {
    adUnit: '/1024858/Mobile_Favorites_320x50',
    adId: 'mobile-favorites',
    adSizes: [[320, 50]],
    adSizeDesktop: [320, 50],
    adSizeMobile: [320, 50],
    adViewType: 'FAVORITES'
  }
};

var loadAdConfig = function loadAdConfig(adIdentifier) {
  var adTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var entitlements = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var adConfigResult = adConfigMap[adIdentifier];
  // TODO: Add additional usertype values based on user entitlements
  var usertype = entitlements.includes('sl_premium') ? 'PREMIUM' : 'ANONYMOUS';
  adConfigResult.adTargets = adTargets;
  adConfigResult.adTargets.push(['usertype', usertype]);
  return adConfigResult;
};

exports.default = loadAdConfig;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/adConfig.js
// module id = 704
// module chunks = 11